import { Stack, TextField } from '@fluentui/react';
import React, { useCallback, useState } from 'react';
import useDebounce from '../../hooks/useDebounce';
import { baseFontFamilyStyle } from '../../shared/styles';

const CustomTextInput = ({
	fieldInfo,
	title = '-',
	currentOfficeTheme,
	headerTextStyle,
	textInputStyles,
	onChange,
	...props
}) => {
	const [inputVal, setInputVal] = useState(fieldInfo.value);

	// Styles
	const inputStyles = {
		fieldGroup: {
			width: '100%',
			minHeight: '38px',
			background: currentOfficeTheme.bodyBackgroundColor,
			color: currentOfficeTheme.bodyForegroundColor,
			':hover': {
				border: `0.8px solid ${currentOfficeTheme.bodyForegroundColor}`,
			},
			border: '1px solid rgba(174, 180, 189, 1)',
		},
		field: {
			color: currentOfficeTheme.bodyForegroundColor,
			fontFamily: baseFontFamilyStyle,
			border: 'none',
			':disabled': {
				background: 'none',
			},
		},

		subComponentStyles: {
			label: getLabelStyle,
		},
	};

	const getLabelStyle = props => {
		return {
			root: {
				color: currentOfficeTheme.bodyForegroundColor,
				fontFamily: baseFontFamilyStyle,
			},
		};
	};

	// Logics

	//@desc helps to change value on input change
	const handleValChange = useCallback((name, val) => {
		setInputVal(val);
		onParentFieldChange(name, val);
	}, []);

	// Updating parent form with delay
	// to minimize rendering
	const onParentFieldChange = useCallback(
		useDebounce((name, val) => {
			onChange(name, val);
		}, 800),
		[],
	);

	return (
		<Stack style={{ marginBottom: '5px' }}>
			<label aria-label={title} style={headerTextStyle} htmlFor={fieldInfo.name}>
				{title}
				{fieldInfo.isRequired && <strong style={{ fontSize: 13, marginTop: '-80%' }}>*</strong>}
			</label>
			<TextField
				placeholder={`Enter a ${title}`}
				name={fieldInfo.name}
				aria-label={`Enter a ${title}`}
				autoComplete="off"
				maxLength={fieldInfo.MaxLength}
				autoAdjustHeight
				styles={{ ...inputStyles, ...textInputStyles }}
				value={inputVal || ''}
				required={fieldInfo.isRequired}
				aria-required={fieldInfo.isRequired}
				aria-errormessage={`${title} is a required field`}
				onChange={(event, option, index) => {
					handleValChange(event?.target?.name, option);
				}}
				{...props}
			/>
		</Stack>
	);
};

export default React.memo(CustomTextInput);
